import React, { Component } from 'react';

import { SCREEN_ID_JOIN_SUNROOM_CLUB_MEMBERSHIP_PAID } from 'client/constants/screenIds';
import withTransitionHook from 'client/helpers/withTransitionHook';
import withScreenId from 'client/helpers/withScreenId';
import withScrollToTop from 'client/helpers/withScrollToTop';

import ButtonDeprecated from 'client/components/ButtonDeprecated';

@withTransitionHook
@withScreenId(SCREEN_ID_JOIN_SUNROOM_CLUB_MEMBERSHIP_PAID)
@withScrollToTop
class SunroomClubMembershipPaidPage extends Component {
  static getPageMetadata = () => ({
    pageTitle: 'Sunroom Select - Membership Paid | Sunroom Rentals',
    keywords: 'sunroom, select, membership',
    description: 'Thanks for paying for the Sunroom Select membership!',
  });

  render() {
    return (
      <div className="page-stopUsingPageClassesWtf">
        <div className="modal success">
          <div className="question-mark" />
          <div className="contentContainer">
            <div className="heroIcon checkmark" />
            <div className="textContainer">
              <span className="headline">Payment successful!</span>
              <span className="explainer">
                Please answer a few questions to finish your Sunroom Select application.
              </span>
            </div>
            <ButtonDeprecated href="/join-sunroom-club/questionnaire">next</ButtonDeprecated>
          </div>
        </div>
      </div>
    );
  }
}

SunroomClubMembershipPaidPage.displayName = 'SunroomClubMembershipPaidPage';

export default SunroomClubMembershipPaidPage;
